module.exports = __webpack_public_path__ + "static/media/shareLockGuide1.353337d4.png";